import React, { useState } from 'react';
import { User, Lock, LogIn, Copy } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showCPFModal, setShowCPFModal] = useState(false);
  const [cpf, setCpf] = useState('');
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  // Função para criar cobrança ASAAS
  const criarCobranca = async (data) => {
    try {
      // const cobrancaResponse = await fetch('https://69.62.94.121:3001/asaas/assinatura', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({
      //     nome: data.usuario || 'julianoTeste2',
      //     cpfCnpj: data.cpfCnpj,
      //     email: data.email || username,
      //     telefone: data.telefone || '21987817656',
      //     "assinatura": {
      //       "billingType": "PIX",
      //       "value": 30,
      //       "nextDueDate": new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString().split('T')[0],
      //       "cycle": "MONTHLY",
      //       "description": "Assinatura mensal",
      //      "callback": {
      //         "successUrl": "https://sistema.belemsistemas.com/redirecionar"
      //       }
      //     }
      //   })
      // });
        navigate('/');

      // const cobrancaData = await cobrancaResponse.json();
      // if (cobrancaData.message === "ASSINATURA PAGA") {
      //   navigate('/');
      // } else if (cobrancaData.invoiceUrl) {
      //   window.location.href = cobrancaData.invoiceUrl;
      // } else {
      //   setError('Erro ao gerar cobrança.');
      //   navigate('/');

      // }
    } catch (err) {
        navigate('/');

      setError('Erro ao criar cobrança ASAAS');
    }
  };

  // Função para adicionar CPF
  const handleAddCPF = async () => {
    if (!cpf) {
      setError('Digite um CPF válido');
      return;
    }
    try {
      const putResponse = await fetch('https://sismoney.com/painel/usuarios.php', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'adicionarCPF',
          idUsuario: userData.idUsuario,
          cpfCnpj: cpf,
        }),
      });
      const putData = await putResponse.json();
      if (putData.success) {
        setShowCPFModal(false);
        // Atualiza o userData com o novo CPF
        const newUserData = { ...userData, cpfCnpj: cpf };
        await criarCobranca(newUserData);
      } else {
        setError(putData.message || 'Erro ao adicionar CPF');
      }
    } catch (err) {
      setError('Erro ao adicionar CPF');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch('https://sismoney.com/painel/usuarios.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'login',
          usuario: username,
          senha: password,
        }),
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('idUsuario', data.idUsuario);

        // Se não tem CPF, pede para adicionar
        if (!data.cpfCnpj) {
          setUserData(data);
          setShowCPFModal(true);
          return;
        } else{
          await criarCobranca(data);
            
        }

      } else {
        setError(data.message || 'Erro ao fazer login');
      }
    } catch (err) {
      console.error('Erro ao conectar ao servidor:', err);
      setError('Erro ao conectar ao servidor');
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('Chave PIX copiada!');
    });
  };

  const pixKeyRegex = /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b/;
  const match = error.match(pixKeyRegex);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl max-w-md w-full p-8 space-y-8">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-indigo-100 dark:bg-indigo-900/50 mb-4">
            <LogIn className="w-8 h-8 text-indigo-600 dark:text-indigo-400" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">Bem-vindo</h2>
          <p className="mt-2 text-gray-600 dark:text-gray-400">Faça login para continuar</p>
        </div>
        {showCPFModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-lg font-bold mb-2">Informe seu CPF</h2>
              <input
                type="text"
                value={cpf}
                onChange={e => setCpf(e.target.value)}
                placeholder="Digite seu CPF"
                className="border p-2 rounded w-full mb-2"
              />
              <button
                onClick={handleAddCPF}
                className="bg-indigo-600 text-white px-4 py-2 rounded mr-2"
              >
                Salvar
              </button>
              <button
                onClick={() => setShowCPFModal(false)}
                className="bg-gray-300 px-4 py-2 rounded"
              >
                Cancelar
              </button>
              {error && <div className="text-red-500 mt-2">{error}</div>}
            </div>
          </div>
        )}
        {error && (
          <div className="text-red-500 text-sm text-center">
            {match ? (
              <>
                {error.split(match[0])[0]}
                <span
                  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', textAlign: 'center' }}
                  onClick={() => copyToClipboard(match[0])}
                  className="flex items-center space-x-1"
                >
                  <Copy className="w-4 h-4 text-blue-600" />
                  <span>{match[0]}</span>
                </span>
                {error.split(match[0])[1]}
              </>
            ) : (
              error
            )}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Usuário</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <User className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
                placeholder="Digite seu usuário"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Senha</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
                placeholder="Digite sua senha"
                required
              />
            </div>
          </div>
          <button
            type="button"
            onClick={() => navigate('/recuperacao')}
            className="text-sm text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >Esqueci a senha</button>
          <button
            type="submit"
            className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >
            <LogIn className="w-5 h-5 mr-2" />
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
